import React from 'react';
import { Calendar, Clock, MapPin, ArrowRight } from 'lucide-react';
import { events } from '../mock';

const Events = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between gap-6 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-semibold text-neutral-500 mb-4 flex items-center gap-2">
              <Calendar className="w-3.5 h-3.5" /> Upcoming Events
            </div>
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-[#0E1112] leading-[1.05]">
              Come and <span className="hl-box hl-cyan">stand</span><br />
              with us in person.
            </h2>
          </div>
          <a href="#" className="link-underline text-sm font-bold text-[#6e12ed] flex items-center gap-2">
            View all events <ArrowRight className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-5">
          {events.map((e, i) => (
            <div
              key={i}
              className="group bg-white rounded-2xl p-6 border border-black/10 hover:border-[#6e12ed] hover:-translate-y-1 transition-all shadow-sm hover:shadow-md"
            >
              <div className="flex items-start gap-4">
                <div className="w-16 h-20 rounded-xl bg-[#6e12ed] flex flex-col items-center justify-center flex-shrink-0">
                  <div className="font-serif text-3xl text-white leading-none font-bold">{e.day}</div>
                  <div className="text-[10px] uppercase text-white font-bold mt-1 tracking-widest">{e.month}</div>
                </div>
                <div className="flex-1">
                  <h3 className="font-serif text-xl font-bold text-[#0E1112] leading-tight">{e.title}</h3>
                  <div className="mt-2 flex flex-wrap gap-3 text-xs text-neutral-600">
                    <span className="inline-flex items-center gap-1">
                      <Clock className="w-3.5 h-3.5" />
                      {e.time}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <MapPin className="w-3.5 h-3.5" />
                      {e.location}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
